import { useState } from 'react';

/**
 * Custom hook for managing popover states in the statistics dashboard
 */
const usePopoverStates = () => {
  // Popover states
  const [demandFilterPopoverOpen, setDemandFilterPopoverOpen] = useState(false);
  const [availabilityFilterPopoverOpen, setAvailabilityFilterPopoverOpen] = useState(false);
  const [onServiceFilterPopoverOpen, setOnServiceFilterPopoverOpen] = useState(false);
  const [waitingTimeFilterPopoverOpen, setWaitingTimeFilterPopoverOpen] = useState(false);
  const [tripFilterPopoverOpen, setTripFilterPopoverOpen] = useState(false);

  // Demand filter handlers
  const handleDemandFilterIconClick = () => {
    setDemandFilterPopoverOpen(true);
  };

  const handleDemandFilterPopoverClose = () => {
    setDemandFilterPopoverOpen(false);
  };

  // Availability filter handlers
  const handleAvailabilityFilterIconClick = () => {
    setAvailabilityFilterPopoverOpen(true);
  };

  const handleAvailabilityFilterPopoverClose = () => {
    setAvailabilityFilterPopoverOpen(false);
  };

  // OnService filter handlers
  const handleOnServiceFilterIconClick = () => {
    setOnServiceFilterPopoverOpen(true);
  };

  const handleOnServiceFilterPopoverClose = () => {
    setOnServiceFilterPopoverOpen(false);
  };

  // WaitingTime filter handlers
  const handleWaitingTimeFilterIconClick = () => {
    setWaitingTimeFilterPopoverOpen(true);
  };

  const handleWaitingTimeFilterPopoverClose = () => {
    setWaitingTimeFilterPopoverOpen(false);
  };

  // Trip filter handlers
  const handleTripFilterIconClick = () => {
    setTripFilterPopoverOpen(true);
  };

  const handleTripFilterPopoverClose = () => {
    setTripFilterPopoverOpen(false);
  };

  return {
    // Popover states
    demandFilterPopoverOpen,
    availabilityFilterPopoverOpen,
    onServiceFilterPopoverOpen,
    waitingTimeFilterPopoverOpen,
    tripFilterPopoverOpen,
    
    // Demand handlers
    handleDemandFilterIconClick,
    handleDemandFilterPopoverClose,
    
    // Availability handlers
    handleAvailabilityFilterIconClick,
    handleAvailabilityFilterPopoverClose,
    
    // OnService handlers
    handleOnServiceFilterIconClick,
    handleOnServiceFilterPopoverClose,
    
    // WaitingTime handlers
    handleWaitingTimeFilterIconClick,
    handleWaitingTimeFilterPopoverClose,
    
    // Trip handlers
    handleTripFilterIconClick,
    handleTripFilterPopoverClose
  };
};

export default usePopoverStates;
